import type { ReportButtonLabels } from '../../report-button-content';

export const reportButton: ReportButtonLabels = {
  report: 'このページを報告',
  title: 'このページの問題を報告',
  reasons: {
    'inaccurate-or-fabricated': '不正確な情報、または捏造された情報',
    'wrong-product': '商品がページの内容と合っていない',
    'sexually-explicit': '性的に露骨なコンテンツ',
    'regulated-product': '処方箋が必要な商品、または規制対象の商品',
    'dangerous-product': '危険な商品',
    'ip-infringement': '自分の権利（商標・著作権）を侵害している',
    other: 'その他',
  },
  detail: '詳細（任意）',
  submit: '報告を送信',
  cancel: 'キャンセル',
  sent: 'ありがとうございます。報告は24時間以内に確認します。',
  failed: '報告を送信できませんでした。もう一度お試しください。',
};
